import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'orgbrain-dialog-text-prompt',
  templateUrl: './support-note.component.html',
  styleUrls: ['./support-note.component.scss'],
    standalone: false
})
export class TextPromptComponent {
  dialogRef = inject<MatDialogRef<TextPromptComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  value = '';

  ok() {
    this.dialogRef.close(this.value);
  }
}
